export default "__VITE_PUBLIC_ASSET__4423078f__"